package ru.notamedia.qah.web

import kotlinx.browser.window
import org.w3c.dom.get
import org.w3c.dom.set

actual fun save(key: String, value: String) {
    window.localStorage[key] = value
}

actual fun get(key: String): String {
    return window.localStorage[key].orEmpty()
}